import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgGreenArrowUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={34}
    height={34}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={17} cy={17} r={17} fill="#39D1AB" fillOpacity={0.17} />
    <g clipPath="url(#greenArrowUp_svg__a)">
      <path
        d="m9.68 22.461 11.225-11.225h-6.374a.782.782 0 0 1-.78-.78c0-.428.35-.78.78-.78l9.031.004v9.035a.78.78 0 0 1-.226.55.78.78 0 0 1-1.33-.553v-6.375L10.781 23.562a.778.778 0 1 1-1.1-1.101Z"
        fill="#39D1AB"
      />
    </g>
    <defs>
      <clipPath id="greenArrowUp_svg__a">
        <path
          fill="#fff"
          transform="scale(-1 1) rotate(45 -15.477 -20.293)"
          d="M0 0h19.633v13.232H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgGreenArrowUp);
export default ForwardRef;
